import React from 'react';

import { Typography } from '@mui/material';

const requiredIconStyles = {
  marginLeft: '4px',
  lineHeight: 'inherit',
  fontSize: 'inherit',
  color: ({ palette }) => palette.text.error,
};

const RequiredIcon = () => (
  <Typography
    className="required-icon"
    component="span"
    sx={requiredIconStyles}
    variant="regular14"
  >
    *
  </Typography>
);

export default RequiredIcon;
